import { TFunction } from "i18next";

export enum ExternalDataUploadTypeEnum {
    CPI_MONTHLY_SERIES_AND_ANNUAL_AVERAGE = 'CPI_MONTHLY_SERIES_AND_ANNUAL_AVERAGE',
    CPI_DIVISION_MONTHLY_SERIES = 'CPI_DIVISION_MONTHLY_SERIES',
    CPI_REGION_MONTHLY_SERIES = 'CPI_REGION_MONTHLY_SERIES',
    ANNUAL_AVERAGE_CPI_BY_DIVISION = 'ANNUAL_AVERAGE_CPI_BY_DIVISION',
    ANNUAL_AVERAGE_CPI_BY_REGION = 'ANNUAL_AVERAGE_CPI_BY_REGION',
}



export const getExternalDataUploadTypeOptions = (
  t: TFunction
) => {
  return Object.values(ExternalDataUploadTypeEnum).map((value) => ({
    label: t(`dataUpload:externalDataUploadTypes.${value}`),
    value: value
  }))
};